module.exports = __webpack_public_path__ + "static/images/bg_get_result2.7eaf250.png";